// RandomNumberGenerator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,   FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Pilih Angka Acak";
const DESCRIPTION =
  "Generator angka acak adalah alat yang membantu Anda menghasilkan angka dalam rentang tertentu yang Anda tentukan, dan Anda dapat memilih satu angka acak atau beberapa angka acak seperti angka acak dari 1 hingga 100 atau angka acak dari 1 hingga 10.";
const KEYWORDS =
  "pilih angka acak, angka acak, angka acak, angka acak dari 1 hingga 100, angka acak dari 1 hingga 10, generator angka acak, hasilkan angka acak, alat generator angka";
const OG_URL = "https://do-calculate.com/calculator/id/random-number-generator";
function RandomNumberGenerator() {
  const [min, setMin] = useState("0");
  const [max, setMax] = useState("100");
  const [count, setCount] = useState("1");
  const [results, setResults] = useState([]);
  const [error, setError] = useState(null);
  const handleMinChange = (event) => {
    setMin(event.target.value);
  };
  const handleMaxChange = (event) => {
    setMax(event.target.value);
  };
  const handleCountChange = (event) => {
    setCount(event.target.value);
  };
  const generateRandomNumbers = () => {
    const minNum = parseInt(min);
    const maxNum = parseInt(max);
    const countNum = parseInt(count);
    if (
      isNaN(minNum) ||
      isNaN(maxNum) ||
      isNaN(countNum) ||
      minNum >= maxNum ||
      countNum <= 0
    ) {
      setError("Silakan masukkan nilai yang valid.");
      setResults([]);
      return;
    }
    const randomNumbers = Array.from(
      { length: countNum },
      () => Math.floor(Math.random() * (maxNum - minNum + 1)) + minNum
    );
    setResults(randomNumbers);
    setError(null);
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Generator angka acak adalah alat yang membantu Anda memilih angka acak atau menghasilkan angka acak dalam rentang tertentu. Ini memungkinkan Anda menentukan batas minimum dan maksimum rentang, serta jumlah angka acak yang ingin Anda hasilkan, seperti menghasilkan angka acak dari 1 hingga 100 atau angka acak dari 1 hingga 10. Alat ini biasanya digunakan dalam berbagai bidang seperti statistik, kriptografi, dan simulasi. Generator angka acak sangat penting dalam memastikan keadilan dalam permainan peluang, membuat kunci enkripsi yang aman, melakukan penelitian ilmiah, dan menguji aplikasi perangkat lunak. Dengan menggunakan generator angka acak, Anda dapat menghilangkan bias dan prediktabilitas, memastikan bahwa setiap angka yang dihasilkan benar-benar acak dan independen dari angka sebelumnya. Alat ini sangat berharga untuk membuat kode unik, kata sandi, dan sampel acak untuk analisis statistik. Secara keseluruhan, generator angka acak adalah alat serbaguna yang menyediakan keacakan dan ketidakpastian dalam berbagai aplikasi.
                </p>
                <hr />
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Pilih Angka Acak - Generator Angka Acak
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="min" className="form-label ms-2">
                      Batas Minimum
                    </label>
                  </b>
                  <input
                    type="number"
                    id="min"
                    value={min}
                    onChange={handleMinChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="0"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="max" className="form-label ms-2">
                      Batas Maksimum
                    </label>
                  </b>
                  <input
                    type="number"
                    id="max"
                    value={max}
                    onChange={handleMaxChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="100"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="count" className="form-label ms-2">
                      Jumlah Angka
                    </label>
                  </b>
                  <input
                    type="number"
                    id="count"
                    value={count}
                    onChange={handleCountChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="1"
                  />
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={generateRandomNumbers}
                  >
                    Hitung
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-7">
                <div>
                  { error && (
                    <div className="alert alert-warning">
                      <b>
                        <u>Error:</u>
                      </b>{" "}
                      {error}
                    </div>
                  )}
                  { results.length > 0 && (
                    <div>
                      <h4>Hasil:</h4>
                      <hr />
                      <div
                        style={{
                          backgroundColor: "#D1E7DD",
                          borderColor: "#c3e6cb",
                          color: "#155724",
                          padding: "15px",
                          marginBottom: "20px",
                          borderRadius: "4px",
                        }}
                      >
                        <ul>
                          {results.map((num, index) => (
                            <li key={index}>{num}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Cara Menggunakan Generator Angka Acak?
              </div>
              <div className="info-section-body">
                <h2>Cara Menggunakan Generator Angka Acak?</h2>
                <p>
                  Untuk menggunakan generator angka acak, yang perlu Anda lakukan hanyalah menentukan batas minimum dan maksimum rentang tempat Anda ingin angka acak muncul. Anda dapat menghasilkan satu angka acak atau beberapa angka acak sesuai kebutuhan Anda. Misalnya, jika Anda ingin memilih angka acak dari 1 hingga 100, tetapkan 1 sebagai batas minimum dan 100 sebagai batas maksimum. Setelah itu, tentukan jumlah angka acak yang ingin Anda hasilkan. Terakhir, tekan tombol "Hitung" untuk mendapatkan hasilnya. Ini dapat digunakan dalam berbagai bidang, seperti mengadakan undian atau mendistribusikan hadiah atau bahkan untuk memilih angka acak dalam permainan.
                </p>
              </div>
            </div>
          </div>
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Apa Itu Generator Angka Acak?</div>
              <div className="info-section-body">
                <h2>Apa Itu Generator Angka Acak?</h2>
                <p>
                  Generator angka acak adalah alat inovatif yang membantu Anda menghasilkan angka acak dalam rentang tertentu yang ditentukan sesuai keinginan Anda. Baik Anda perlu memilih angka acak dari 1 hingga 10 atau menghasilkan angka acak yang lebih besar seperti angka acak dari 1 hingga 100, alat ini memberi Anda fleksibilitas untuk menentukan rentang yang sesuai. Selain itu, Anda dapat menentukan jumlah angka yang ingin Anda hasilkan sekaligus, menjadikan alat ini ideal untuk digunakan dalam berbagai bidang seperti statistik, kriptografi, permainan, dan aktivitas apa pun yang memerlukan produksi angka acak yang sebenarnya.
                </p>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default RandomNumberGenerator;